export const settings_profile_organization_en = {
  "profile-organization": "Account & Organization",
  account_name_title: "Account name",
  account_name_desc:
    "Set the first and last name associated with this account. This will be used across the platform for identification and communication.",
  account_details_title: "Account details",
  account_details_desc:
    "Update basic account details like email, phone number, and preferred time zone. These settings help personalize communication and notifications.",
  translation_support_title: "Translation support",
  translation_support_desc:
    "Automatically translates company and prospect details like titles, descriptions, and keywords. Credit usage may apply for each page search.",
  change_password_title: "Change Password",
  change_password_desc:
    "Update the current password for this account. Make sure to use a strong and secure combination.",
  workspace_title: "Workspaces",
  workspace_desc:
    "Manage and switch between your available workspaces. Each workspace has its own team, settings, and subscription. Select the one you'd like to work on.",
  profile_workspace_description_empty:
    "This workspace does not have a description yet.",
  setting_profile_workspace_edit_dialog_title: "Edit Workspace",
  workspace_name: "Workspace name",
  workspace_description_placeholder:
    "Add a short description about this workspace...",
  workspace_name_placeholder: "Enter workspace name",
  enable_translation_support: "Enable translation support",
  current_password: "Current password",
  forget_password_question: "Forgot current password?",
  new_password: "New password",
  confirm_new_password: "Confirm new password",
  current_password_placeholder: "Enter your existing password",
  new_password_placeholder: "Create a new password (8+ characters recommended)",
  confirm_new_password_placeholder: "Re-enter the new password to confirm",
  given_name: "First name",
  given_name_placeholder: "Enter first name",
  family_name_placeholder: "Enter last name",
  family_name: "Last name",
  email_placeholder: "example@gmail.com",
  setting_profile_organization_timezone: "Timezone",
  password_required: "please enter new password",
  confirm_password_required: "please confirm the new password",
  passwords_not_match: "two passwords don't match",

  no_changes: "no changes",
  phone_number: "Phone number",

  developer: "developer",
  account_growth: "account growth",

  renews_on: "Renews {date}",
  admin_contact: "Admin contact",
  you_are_the_admin: "You're the account admin",
  your_admin: "Your Admin",
};

export const settings_profile_organization_zh = {
  "profile-organization": "账户与组织",
  account_name_title: "账户名称",
  account_name_desc:
    "设置与此账户关联的名字和姓氏。该信息将在平台中用于识别和沟通。",
  account_details_title: "账户详情",
  account_details_desc:
    "更新基本账户信息，如邮箱、电话号码和首选时区。这些设置有助于个性化通信和通知。",
  translation_support_title: "翻译支持",
  translation_support_desc:
    "自动翻译公司和潜在客户的职位、描述和关键词等信息。每次页面搜索可能会消耗积分。",
  change_password_title: "更改密码",
  change_password_desc: "更新当前账户密码。请确保使用强密码以保障安全。",
  workspace_title: "工作区",
  workspace_desc:
    "管理并切换可用的工作区。每个工作区都有自己的团队、设置和订阅。请选择你想使用的工作区。",
  profile_workspace_description_empty: "该工作区尚未添加描述。",
  setting_profile_workspace_edit_dialog_title: "编辑工作区",
  workspace_name: "工作区名称",
  workspace_description_placeholder: "为该工作区添加简短描述...",
  workspace_name_placeholder: "输入工作区名称",
  enable_translation_support: "启用翻译支持",
  current_password: "当前密码",
  forget_password_question: "忘记当前密码？",
  new_password: "新密码",
  confirm_new_password: "确认新密码",
  current_password_placeholder: "请输入当前密码",
  new_password_placeholder: "创建新密码（建议8个以上字符）",
  confirm_new_password_placeholder: "请再次输入新密码以确认",
  given_name: "名字",
  given_name_placeholder: "请输入名字",
  family_name: "姓氏",
  family_name_placeholder: "请输入姓氏",
  email_placeholder: "example@gmail.com",
  setting_profile_organization_timezone: "时区",
  password_required: "请输入新密码",
  confirm_password_required: "请确认新密码",
  passwords_not_match: "两次输入的密码不一致",

  no_changes: "无更改",
  phone_number: "电话号码",
  developer: "开发者",
  account_growth: "账户增长",
  renews_on: "续费日期：{date}",
  admin_contact: "管理员联系人",
  you_are_the_admin: "您是账户管理员",
  your_admin: "您的账户管理员",
};

export const settings_profile_organization_zh_tw = {
  "profile-organization": "帳戶與組織",
  account_name_title: "帳戶名稱",
  account_name_desc: "設定此帳戶的名字與姓氏，將用於平台內的識別與溝通。",
  account_details_title: "帳戶詳情",
  account_details_desc:
    "更新基本帳戶資訊，如電子郵件、電話號碼與偏好時區。這些設定有助於個人化溝通與通知。",
  translation_support_title: "翻譯支援",
  translation_support_desc:
    "自動翻譯公司與潛在客戶的職稱、描述與關鍵字。每次搜尋頁面可能會消耗點數。",
  change_password_title: "變更密碼",
  change_password_desc: "更新此帳戶的現有密碼。請確保使用強且安全的組合。",
  workspace_title: "工作區",
  workspace_desc:
    "管理並切換可用的工作區。每個工作區擁有獨立的團隊、設定與訂閱。請選擇你要使用的工作區。",
  profile_workspace_description_empty: "此工作區尚未新增描述。",
  setting_profile_workspace_edit_dialog_title: "編輯工作區",
  workspace_name: "工作區名稱",
  workspace_description_placeholder: "新增關於此工作區的簡短描述...",
  workspace_name_placeholder: "輸入工作區名稱",
  enable_translation_support: "啟用翻譯支援",
  current_password: "目前密碼",
  forget_password_question: "忘記目前密碼？",
  new_password: "新密碼",
  confirm_new_password: "確認新密碼",
  current_password_placeholder: "輸入你目前的密碼",
  new_password_placeholder: "建立新密碼（建議8字元以上）",
  confirm_new_password_placeholder: "再次輸入新密碼以確認",
  given_name: "名字",
  given_name_placeholder: "輸入名字",
  family_name: "姓氏",
  family_name_placeholder: "輸入姓氏",
  email_placeholder: "example@gmail.com",
  setting_profile_organization_timezone: "時區",
  password_required: "請輸入新密碼",
  confirm_password_required: "請確認新密碼",
  passwords_not_match: "兩次輸入的密碼不一致",

  no_changes: "無更改",
  phone_number: "電話號碼",
  developer: "開發者",
  account_growth: "帳戶成長",
  renews_on: "續訂日期：{date}",
  admin_contact: "管理員聯絡人",
  you_are_the_admin: "你是帳戶管理員",
  your_admin: "你的帳戶管理員",
};
// Japanese (日本語)
export const settings_profile_organization_ja = {
  "profile-organization": "アカウントと組織",
  account_name_title: "アカウント名",
  account_name_desc:
    "プラットフォーム内での識別とコミュニケーションに使用されるアカウントの名前を設定します。",
  account_details_title: "アカウント詳細",
  account_details_desc:
    "メールアドレス、電話番号、タイムゾーンなどの基本情報を更新します。これらの設定はパーソナライズされたコミュニケーションと通知に役立ちます。",
  translation_support_title: "翻訳サポート",
  translation_support_desc:
    "会社と見込み客の役職、説明、キーワードを自動翻訳します。各検索ページでクレジットが消費される場合があります。",
  change_password_title: "パスワード変更",
  change_password_desc:
    "アカウントの現在のパスワードを更新します。強力で安全な組み合わせを使用してください。",
  workspace_title: "ワークスペース",
  workspace_desc:
    "利用可能なワークスペースを管理および切り替えます。各ワークスペースには独立したチーム、設定、サブスクリプションがあります。使用するワークスペースを選択してください。",
  profile_workspace_description_empty:
    "このワークスペースにはまだ説明が追加されていません。",
  setting_profile_workspace_edit_dialog_title: "ワークスペース編集",
  workspace_name: "ワークスペース名",
  workspace_description_placeholder:
    "このワークスペースについての簡単な説明を追加...",
  workspace_name_placeholder: "ワークスペース名を入力",
  enable_translation_support: "翻訳サポートを有効化",
  current_password: "現在のパスワード",
  forget_password_question: "現在のパスワードをお忘れですか？",
  new_password: "新しいパスワード",
  confirm_new_password: "新しいパスワード（確認）",
  current_password_placeholder: "現在のパスワードを入力",
  new_password_placeholder: "新しいパスワードを作成（8文字以上推奨）",
  confirm_new_password_placeholder: "確認のため新しいパスワードを再入力",
  given_name: "名",
  given_name_placeholder: "名を入力",
  family_name: "姓",
  family_name_placeholder: "姓を入力",
  email_placeholder: "example@gmail.com",
  setting_profile_organization_timezone: "タイムゾーン",
  password_required: "新しいパスワードを入力してください",
  confirm_password_required: "新しいパスワードを確認してください",
  passwords_not_match: "パスワードが一致しません",
  no_changes: "変更なし",
  phone_number: "電話番号",
  developer: "デベロッパー",
  account_growth: "アカウント成長",
  renews_on: "次回更新日: {date}",
  admin_contact: "管理者連絡先",
  you_are_the_admin: "あなたはアカウント管理者です",
  your_admin: "あなたのアカウント管理者",
};

// Korean (한국어)
export const settings_profile_organization_ko = {
  "profile-organization": "계정 및 조직",
  account_name_title: "계정 이름",
  account_name_desc:
    "플랫폼 내 식별 및 커뮤니케이션에 사용될 계정의 이름을 설정합니다.",
  account_details_title: "계정 상세 정보",
  account_details_desc:
    "이메일, 전화번호, 선호 시간대 등 기본 계정 정보를 업데이트합니다. 이러한 설정은 개인화된 커뮤니케이션과 알림에 도움이 됩니다.",
  translation_support_title: "번역 지원",
  translation_support_desc:
    "회사와 잠재 고객의 직책, 설명 및 키워드를 자동 번역합니다. 각 검색 페이지에서 크레딧이 소모될 수 있습니다.",
  change_password_title: "비밀번호 변경",
  change_password_desc:
    "현재 계정 비밀번호를 업데이트합니다. 강력하고 안전한 조합을 사용하세요.",
  workspace_title: "워크스페이스",
  workspace_desc:
    "사용 가능한 워크스페이스를 관리하고 전환합니다. 각 워크스페이스는 독립적인 팀, 설정 및 구독을 가집니다. 사용할 워크스페이스를 선택하세요.",
  profile_workspace_description_empty:
    "이 워크스페이스에는 아직 설명이 추가되지 않았습니다.",
  setting_profile_workspace_edit_dialog_title: "워크스페이스 편집",
  workspace_name: "워크스페이스 이름",
  workspace_description_placeholder:
    "이 워크스페이스에 대한 간단한 설명 추가...",
  workspace_name_placeholder: "워크스페이스 이름 입력",
  enable_translation_support: "번역 지원 활성화",
  current_password: "현재 비밀번호",
  forget_password_question: "현재 비밀번호를 잊으셨나요?",
  new_password: "새 비밀번호",
  confirm_new_password: "새 비밀번호 확인",
  current_password_placeholder: "현재 비밀번호 입력",
  new_password_placeholder: "새 비밀번호 생성 (8자 이상 권장)",
  confirm_new_password_placeholder: "확인을 위해 새 비밀번호 다시 입력",
  given_name: "이름",
  given_name_placeholder: "이름 입력",
  family_name: "성",
  family_name_placeholder: "성 입력",
  email_placeholder: "example@gmail.com",
  setting_profile_organization_timezone: "시간대",
  password_required: "새 비밀번호를 입력하세요",
  confirm_password_required: "새 비밀번호를 확인하세요",
  passwords_not_match: "비밀번호가 일치하지 않습니다",
  no_changes: "변경 사항 없음",
  phone_number: "전화번호",
  developer: "개발자",
  account_growth: "계정 성장",
  renews_on: "갱신일: {date}",
  admin_contact: "관리자 연락처",
  you_are_the_admin: "귀하는 계정 관리자입니다",
  your_admin: "내 계정 관리자",
};

// Hindi (हिन्दी)
export const settings_profile_organization_hi = {
  "profile-organization": "अकाउंट और संगठन",
  account_name_title: "अकाउंट नाम",
  account_name_desc:
    "प्लेटफॉर्म पर पहचान और संचार के लिए इस अकाउंट का नाम और उपनाम सेट करें।",
  account_details_title: "अकाउंट विवरण",
  account_details_desc:
    "ईमेल, फोन नंबर और पसंदीदा टाइमज़ोन जैसी बेसिक जानकारी अपडेट करें। ये सेटिंग्स पर्सनलाइज्ड कम्युनिकेशन और नोटिफिकेशन में मदद करती हैं।",
  translation_support_title: "अनुवाद सहायता",
  translation_support_desc:
    "कंपनी और संभावित ग्राहकों के जॉब टाइटल, विवरण और कीवर्ड्स का ऑटोमेटिक अनुवाद करें। प्रत्येक सर्च पेज क्रेडिट्स खर्च कर सकता है।",
  change_password_title: "पासवर्ड बदलें",
  change_password_desc:
    "इस अकाउंट का मौजूदा पासवर्ड अपडेट करें। कृपया एक मजबूत और सुरक्षित कॉम्बिनेशन का उपयोग करें।",
  workspace_title: "वर्कस्पेस",
  workspace_desc:
    "उपलब्ध वर्कस्पेस को मैनेज और स्विच करें। प्रत्येक वर्कस्पेस में अलग टीम, सेटिंग्स और सब्सक्रिप्शन होते हैं। कृपया उस वर्कस्पेस को चुनें जिसका आप उपयोग करना चाहते हैं।",
  profile_workspace_description_empty:
    "इस वर्कस्पेस में अभी तक कोई विवरण नहीं जोड़ा गया है।",
  setting_profile_workspace_edit_dialog_title: "वर्कस्पेस संपादित करें",
  workspace_name: "वर्कस्पेस नाम",
  workspace_description_placeholder:
    "इस वर्कस्पेस के बारे में संक्षिप्त विवरण जोड़ें...",
  workspace_name_placeholder: "वर्कस्पेस नाम दर्ज करें",
  enable_translation_support: "अनुवाद सहायता सक्षम करें",
  current_password: "वर्तमान पासवर्ड",
  forget_password_question: "वर्तमान पासवर्ड भूल गए?",
  new_password: "नया पासवर्ड",
  confirm_new_password: "नए पासवर्ड की पुष्टि करें",
  current_password_placeholder: "अपना वर्तमान पासवर्ड दर्ज करें",
  new_password_placeholder: "नया पासवर्ड बनाएँ (8+ वर्णों की सिफारिश की गई)",
  confirm_new_password_placeholder:
    "पुष्टि के लिए नया पासवर्ड फिर से दर्ज करें",
  given_name: "पहला नाम",
  given_name_placeholder: "पहला नाम दर्ज करें",
  family_name: "उपनाम",
  family_name_placeholder: "उपनाम दर्ज करें",
  email_placeholder: "example@gmail.com",
  setting_profile_organization_timezone: "समय क्षेत्र",
  password_required: "कृपया नया पासवर्ड दर्ज करें",
  confirm_password_required: "कृपया नए पासवर्ड की पुष्टि करें",
  passwords_not_match: "पासवर्ड मेल नहीं खाते",
  no_changes: "कोई परिवर्तन नहीं",
  phone_number: "फोन नंबर",
  developer: "डेवलपर",
  account_growth: "अकाउंट ग्रोथ",
  renews_on: "नवीनीकरण तिथि: {date}",
  admin_contact: "एडमिन संपर्क",
  you_are_the_admin: "आप इस अकाउंट के एडमिन हैं",
  your_admin: "आपके अकाउंट एडमिन",
};
